<div class="px-3 pt-3 pb-3">
  <mat-card>
    <mat-card-content class="p-0">
      <app-datatable
        [configurationInput]="datatableConfigurations"
        [rowData]="formattedDatatableRows()"
        [columns]="datatableColumns"
        [total]="this.store.dataTotal$()"
        (deleteClick)="selectedDatatableItems().length >= 2 ? initializeBulkDelete() : initializeDelete()"
        (editClick)="initializeEdit()"
        (addClick)="initializeAdd()"
        (dataRefreshRequest)="datatableParams$.next($event)"
        (selectedItemsChange)="selectedDatatableItems.set($event)"
        [customColumnDef]="[{ name: 'key', template: boardIdCell, isSortable: true }]"
      />
    </mat-card-content>
  </mat-card>
</div>

<ng-template #boardIdCell let-row="row">
  {{ row.key }}
  <mat-chip *ngIf="!row.isAdmin" class="chip-hover-remove" [disableRipple]="true">
    {{ 'field.member' | translate | uppercase }}
  </mat-chip>
</ng-template>
<ng-template #addEditFormDialog>
  <h1 mat-dialog-title>
    {{ addEditModalTitle() }}
  </h1>
  <form [formGroup]="addEditForm" (ngSubmit)="onFormDialogSubmit()" #form="ngForm">
    <div mat-dialog-content>
      <div class="row">
        <div class="col-12 mb-3">
          <span class="dialog-section"
            ><mat-icon>link</mat-icon> {{ 'system.dialogSection.assignment' | translate }}</span
          >
        </div>
        <div class="col-lg-4">
          <mat-dropdown
            [options]="store.workspaceOptions()"
            [isFormSubmitted]="form.submitted"
            [configurationInput]="{
              hasDelayedDefaultValue: true,
              hasMatError: true,
              singleSelection: true,
              text: 'field.workspace' | translate,
              repositionDropdownList: true,
            }"
            [formControl]="addEditForm.controls.workspace"
            [isLoading]="(store.workspaceOptionsLoading$ | async) === store.ELoadStatus.loading"
            (search)="getWorkspaces($event)"
          ></mat-dropdown>
        </div>
        <div class="col-lg-4">
          <mat-dropdown
            [options]="store.parentBoardIdOptions()"
            [configurationInput]="{
              hasDelayedDefaultValue: true,
              singleSelection: true,
              text: 'field.parentBoard' | translate,
              repositionDropdownList: true,
            }"
            [formControl]="addEditForm.controls.parentBoard"
            [isLoading]="(store.parentBoardIdOptionsLoading$ | async) === store.ELoadStatus.loading"
            (search)="getParentBoards($event)"
          ></mat-dropdown>
        </div>
        <div *ngIf="oeeTrackerStore.isAvailable" class="col-lg-4">
          <mat-dropdown
            [options]="oeeTrackerStore.lineOptions()"
            [configurationInput]="{
              hasDelayedDefaultValue: true,
              isClientSide: true,
              singleSelection: true,
              text: 'field.oeeLine' | translate,
              repositionDropdownList: true,
            }"
            [formControl]="addEditForm.controls.oeeLine"
            [isLoading]="(oeeTrackerStore.lineOptionsLoading$ | async) === store.ELoadStatus.loading"
          ></mat-dropdown>
        </div>
        <div class="col-12 mb-3">
          <span class="dialog-section"
            ><mat-icon>description</mat-icon> {{ 'system.dialogSection.generalInformation' | translate }}</span
          >
        </div>
        <div class="col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'field.name' | translate }}</mat-label>
            <input matInput formControlName="name" />
            <mat-error [control]="addEditForm.get('name')"></mat-error>
          </mat-form-field>
        </div>
        <div class="col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'field.key' | translate }}</mat-label>
            <input matInput formControlName="key" maxlength="3" />
            <mat-error [control]="addEditForm.get('key')"></mat-error>
          </mat-form-field>
        </div>
        <div class="col-12 mb-3">
          <span class="dialog-section"
            ><mat-icon>groups</mat-icon> {{ 'system.dialogSection.boardAssignees' | translate }}</span
          >
        </div>
        <div class="col-lg-4">
          <mat-dropdown
            [options]="store.adminOptions()"
            [configurationInput]="{ text: ('field.boardAdmins' | translate), repositionDropdownList: true }"
            [formControl]="addEditForm.controls.admins"
            [isLoading]="(store.adminOptionsLoading$ | async) === store.ELoadStatus.loading"
            (search)="getAdmins($event)"
          ></mat-dropdown>
        </div>
        <div class="col-lg-4">
          <mat-dropdown
            [options]="store.userOptions()"
            [configurationInput]="{ text: ('field.users' | translate), repositionDropdownList: true }"
            [formControl]="addEditForm.controls.users"
            [isLoading]="(store.userOptionsLoading$ | async) === store.ELoadStatus.loading"
            (search)="getUsers($event)"
          ></mat-dropdown>
        </div>
        <div class="col-lg-4">
          <mat-dropdown
            [options]="store.teamOptions()"
            [configurationInput]="{ text: ('field.teams' | translate), repositionDropdownList: true }"
            [formControl]="addEditForm.controls.teams"
            [isLoading]="(store.teamOptionsLoading$ | async) === store.ELoadStatus.loading"
            (search)="getTeams($event)"
          ></mat-dropdown>
        </div>
        <ng-container *ngIf="isAiEnabled">
          <div class="col-12 mb-3">
            <span class="dialog-section"
              ><mat-icon>auto_awesome</mat-icon> {{ 'system.dialogSection.artificialIntelligence' | translate }}</span
            >
          </div>
          <div class="col-lg-6">
            <mat-dropdown
              [options]="aiAgentOptions$()"
              [configurationInput]="{
                hasDelayedDefaultValue: true,
                isClientSide: true,
                singleSelection: true,
                text: 'field.defaultAiAgent' | translate,
                repositionDropdownList: true,
              }"
              [formControl]="addEditForm.controls.aiAgent"
              [isLoading]="store.aiAgentOptionsLoading() === store.ELoadStatus.loading"
            ></mat-dropdown>
            <p class="ai-agent-hint">{{ 'page.artificialIntelligence.defaultAgentHint' | translate }}</p>
          </div>
          <div *ngFor="let assistantType of aiAssistantTypes" class="col-lg-6">
            <mat-dropdown
              [options]="aiAgentOptions$()"
              [configurationInput]="{
                hasDelayedDefaultValue: true,
                isClientSide: true,
                singleSelection: true,
                text: 'page.artificialIntelligence.assistantType.' + assistantType | translate,
                repositionDropdownList: true,
              }"
              [formControl]="addEditForm.controls.aiAgents.controls[assistantType]"
              [isLoading]="store.aiAgentOptionsLoading() === store.ELoadStatus.loading"
            ></mat-dropdown>
          </div>
          <div class="col-12">
            <p class="ai-agent-hint">{{ 'page.artificialIntelligence.assistantTypeAgentHint' | translate }}</p>
          </div>
          <div class="col-12">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'field.instructions' | translate }}</mat-label>
              <textarea matInput rows="4" formControlName="instructions"></textarea>
              <mat-hint>{{ 'page.artificialIntelligence.boardInstructionsHint' | translate }}</mat-hint>
              <mat-error [control]="addEditForm.controls.instructions"></mat-error>
            </mat-form-field>
          </div>
        </ng-container>
        <div *ngFor="let type of itemTypes" class="col-xl-12 col-md-12 mb-3 mt-3">
          <span class="dialog-section"
            ><mat-icon class="material-icons-outlined">{{
              type === EItemType.issue ? 'assignment_late' : 'directions_run'
            }}</mat-icon>
            {{ 'system.dialogSection.' + type + 'Fields' | translate }}</span
          >
          <app-datatable
            [configurationInput]="{
              isClientSide: true,
              isDraggable: false,
              isHeaderRowEnabled: false,
              isPaginationEnabled: false,
              isSearchEnabled: false,
              isLoaderEnabled: isEditDialog(),
              areCheckboxesEnabled: false,
            }"
            [rowData]="issueConfigurationOptionsDatatableRows()[type]"
            [columns]="issueConfigurationOptionsDatatableColumns"
            [customColumnDef]="[
              { name: 'itemCategory', template: itemCategoryDropdown, isSortable: false },
              { name: 'fieldSet', template: fieldSetDropdown, isSortable: false },
              { name: 'workflow', template: workflowDropdown, isSortable: false },
              { name: 'ishikawaTemplate', template: ishikawaTemplateDropdown, isSortable: false },
              { name: 'delete', template: fieldOptionDelete, isSortable: false },
            ]"
            [total]="10000"
          />
          <mat-error
            [control]="
              type === EItemType.action
                ? itemConfigurationValidationData.exampleActionFormControl
                : itemConfigurationValidationData.exampleIssueFormControl
            "
          ></mat-error>
          <div class="mt-2">
            <button
              mat-stroked-button
              class="w-100 mb-2"
              type="button"
              (click)="addItemConfiguration(type)"
              *ngIf="!addEditForm.disabled"
            >
              <mat-icon>add</mat-icon>
              {{
                'button.addConfiguration'
                  | translate
                    : {
                        type:
                          type === EItemType.action ? ('business.action' | translate) : ('business.issue' | translate),
                      }
              }}
            </button>
          </div>

          <ng-template #fieldOptionDelete let-row="row">
            <button mat-mini-fab class="v-middle" (click)="deleteIssueConfigurationOption(row.id, type)">
              <mat-icon>delete</mat-icon>
            </button>
          </ng-template>

          <ng-template #itemCategoryDropdown let-row="row" let-index="index">
            <div class="pb-3 pt-3">
              <mat-dropdown
                [configurationInput]="itemCategoryDropdownConfigurations"
                [formControl]="this.itemConfigurationOptions()[type][index].itemCategory"
                [options]="categoryOptions$()"
              ></mat-dropdown>
            </div>
          </ng-template>

          <ng-template #fieldSetDropdown let-row="row" let-index="index">
            <mat-dropdown
              [configurationInput]="fieldSetDropdownConfigurations"
              [formControl]="this.itemConfigurationOptions()[type][index].fieldSet"
              [options]="(store.fieldSetOptions$ | async)!"
            ></mat-dropdown>
          </ng-template>

          <ng-template #workflowDropdown let-row="row" let-index="index">
            <mat-dropdown
              [configurationInput]="workflowDropdownConfigurations"
              [formControl]="this.itemConfigurationOptions()[type][index].workflow"
              [options]="workflowOptions$()"
            ></mat-dropdown>
          </ng-template>

          <ng-template #ishikawaTemplateDropdown let-row="row" let-index="index">
            <mat-dropdown
              [configurationInput]="ishikawaTemplateDropdownConfigurations"
              [formControl]="this.itemConfigurationOptions()[type][index].ishikawaTemplate"
              [options]="ishikawaTemplateOptions$()"
            ></mat-dropdown>
          </ng-template>
        </div>
      </div>
    </div>
    <mat-dialog-actions align="end">
      <button matButton="tonal" mat-dialog-close>{{ 'button.cancel' | translate }}</button>
      <button *ngIf="!addEditForm.disabled" mat-flat-button type="submit">
        {{ addEditSubmitButtonText() }}
      </button>
    </mat-dialog-actions>
  </form>
</ng-template>
